import { DateFormatType } from "../types/date.type"

export const formatNumeric = (number: number, decimalPlaces: number = 0) => {
  const fixed = number.toFixed(decimalPlaces)
  const parts = fixed.split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return parts.join('.')
}

export const formatUnit = (unit: string) => {
  if (unit === 'gram') {
    return 'กรัม'
  } else if (unit === 'kg') {
    return 'กิโลกรัม'
  } else if (unit === 'liter') {
    return 'ลิตร'
  } else if (unit === 'pack') {
    return 'แพ็ค'
  } else {
    return unit
  }
}


export const formatDate = (date: string | null | undefined, type: DateFormatType): string => {
  if (!date) return ""

  const d = new Date(date)

  // ถ้า date ไม่ถูกต้อง
  if (isNaN(d.getTime())) return ""

  const day = d.getDate()
  const month = d.toLocaleString("th-TH", { month: type === "long" ? "long" : "2-digit" })
  const year = d.getFullYear() + 543
  const hours = d.getHours().toString().padStart(2, "0")
  const minutes = d.getMinutes().toString().padStart(2, "0")

  const formats: Record<DateFormatType, string> = {
    long: `${day} ${month} ${year}`,                      
    short: `${day.toString().padStart(2,"0")}/${month}/${year}`, 
    withTime: `${day.toString().padStart(2,"0")}/${month}/${year} ${hours}.${minutes} น.` 
  }

  return formats[type]
}

export const formatDateForTag = (startDate: Date | null, endDate: Date | null): string => {
  const formatDateValue = (date: Date) => {
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear()
    return `${day}/${month}/${year}`
  }
  
  if (startDate && endDate) {
    return `${formatDateValue(startDate)} - ${formatDateValue(endDate)}`
  }
  if (startDate) {
    return `From ${formatDateValue(startDate)}`
  }
  if (endDate) {
    return `Until ${formatDateValue(endDate)}`
  }
  return ''
}